const USERS_KEY = 'shipment_users';
const SESSION_KEY = 'shipment_session';

const getUsers = () => JSON.parse(localStorage.getItem(USERS_KEY) || '[]');
const saveUsers = (users) => localStorage.setItem(USERS_KEY, JSON.stringify(users));

export const localAuth = {
  signUp: ({ email, password, fullName, mobile, country, monthlyVolume, platforms }) => {
    const users = getUsers();
    if (users.find(u => u.email === email)) {
      return { error: { message: 'User already exists with this email.' } };
    }
    const user = {
      id: crypto.randomUUID(),
      email,
      password,
      full_name: fullName,
      mobile: mobile || '',
      country: country || '',
      monthly_volume: monthlyVolume || '',
      platforms: platforms || [],
      credits: 100,
    };
    saveUsers([...users, user]);
    const session = { user, access_token: 'local-token' };
    localStorage.setItem(SESSION_KEY, JSON.stringify(session));
    return { data: { user, session }, error: null };
  },

  signIn: ({ email, password }) => {
    const users = getUsers();
    const user = users.find(u => u.email === email && u.password === password);
    if (!user) return { error: { message: 'Invalid email or password.' } };
    const session = { user, access_token: 'local-token' };
    localStorage.setItem(SESSION_KEY, JSON.stringify(session));
    return { data: { user, session }, error: null };
  },

  signOut: () => {
    localStorage.removeItem(SESSION_KEY);
    return { error: null };
  },

  getSession: () => {
    const session = JSON.parse(localStorage.getItem(SESSION_KEY) || 'null');
    return { data: { session }, error: null };
  },

  getUser: () => {
    const session = JSON.parse(localStorage.getItem(SESSION_KEY) || 'null');
    return { data: { user: session?.user || null }, error: null };
  },

  getCredits: () => {
    const session = JSON.parse(localStorage.getItem(SESSION_KEY) || 'null');
    return session?.user?.credits ?? 0;
  },

  addCredits: (amount) => {
    const session = JSON.parse(localStorage.getItem(SESSION_KEY) || 'null');
    if (!session?.user) return false;
    session.user.credits = (session.user.credits || 0) + amount;
    localStorage.setItem(SESSION_KEY, JSON.stringify(session));
    const users = getUsers();
    const idx = users.findIndex(u => u.id === session.user.id);
    if (idx !== -1) {
      users[idx].credits = session.user.credits;
      saveUsers(users);
    }
    return session.user.credits;
  },

  deductCredit: () => {
    const session = JSON.parse(localStorage.getItem(SESSION_KEY) || 'null');
    if (!session?.user) return false;
    if ((session.user.credits || 0) <= 0) return false;
    session.user.credits = (session.user.credits || 0) - 1;
    localStorage.setItem(SESSION_KEY, JSON.stringify(session));
    const users = getUsers();
    const idx = users.findIndex(u => u.id === session.user.id);
    if (idx !== -1) {
      users[idx].credits = session.user.credits;
      saveUsers(users);
    }
    return true;
  },

  onAuthStateChange: (callback) => {
    const session = JSON.parse(localStorage.getItem(SESSION_KEY) || 'null');
    callback('INITIAL_SESSION', session);
    return { data: { subscription: { unsubscribe: () => {} } } };
  },
};